<script lang="ts">
  let { size = "60px" } = $props<{
    size?: string
  }>()

  // copied from https://github.com/Schum123/svelte-loading-spinners/blob/master/src/Circle.svelte
</script>

<div class="overlay">
  <div
    class="loading-spinner"
    style:height={size}
    style:width={size}
    style:border-width={`calc(${size} / 15)`}
  ></div>
</div>

<style>
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: var(--medium-spacing);

    z-index: var(--loading-overlay-z-index);
  }

  .loading-spinner {
    --color: var(--loading-spinner-color, #ff3e00);
    border-color: var(--color) transparent var(--color) var(--color);
    border-style: solid;
    border-image: initial;
    border-radius: 50%;
    animation: 0.75s linear 0s infinite normal none running rotate;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
